import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
    name: 'SectionHeader',
})
export default class default_1 extends Vue {
    @Prop()
    title;
    @Prop()
    caption;
}
